/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * The order of a donut's slices, and of its legend: biggest first. Read in a fixed order,
 * a legend made the reader hunt for the largest figure ("Information 121" fourth, under
 * 46 and 29). The sort is stable, so equal counts keep the order they came in.
 */
export const bySliceSize = (a: { value: number }, b: { value: number }) =>
  b.value - a.value;

/**
 * Common configuration for pie charts
 * Creates a thin donut style with increased spacing between slices
 */
export const commonPieConfig = {
  margin: { top: 20, right: 80, bottom: 20, left: 80 },
  innerRadius: 0.7, // Thin donut style (increased from 0.5)
  padAngle: 2, // More space between slices (increased from 0.7)
  cornerRadius: 8,
  activeOuterRadiusOffset: 8,
  borderWidth: 1,
  borderColor: {
    from: "color",
    modifiers: [["darker", 0.2]],
  } as any,
  colors: { datum: "data.color" },
  arcLinkLabelsSkipAngle: 10,
  arcLinkLabelsThickness: 2,
  arcLinkLabelsColor: { from: "color" },
  enableArcLabels: false,
};

/**
 * Compact pie configuration for smaller charts
 * Used in Performance component where space is limited
 */
export const compactPieConfig = {
  margin: { top: 10, right: 10, bottom: 10, left: 10 },
  innerRadius: 0.7, // Thin donut style
  padAngle: 2, // More space between slices
  cornerRadius: 8,
  activeOuterRadiusOffset: 8,
  borderWidth: 1,
  borderColor: {
    from: "color",
    modifiers: [["darker", 0.2]],
  } as any,
  colors: { datum: "data.color" },
  enableArcLinkLabels: false,
  enableArcLabels: true, // Show values in compact version
};
